import React, { useState, useEffect } from 'react'
import {
  Container, Paper, Typography, Box, Button, Alert, CircularProgress,
} from '@mui/material'
import { gql, useQuery, useMutation } from '@apollo/client'
import PayoutConfigForm from '../components/PayoutConfig/PayoutConfigForm'
import { getPlatformPayoutConfig, savePlatformPayoutConfig } from '../apollo/mutations'

const GET = gql`${getPlatformPayoutConfig}`
const SAVE = gql`${savePlatformPayoutConfig}`

const NUM_FIELDS = [
  'opt1HourlyRate', 'opt2HourlyRate', 'opt2PerOrderBonus',
  'opt3FlatFeePerOrder', 'opt4BaseFee', 'opt4PerMileRate',
  'opt5PercentOfDeliveryFee', 'opt6MinimumPerDelivery', 'opt8BonusPerExtraOrder',
]
const BOOL_FIELDS = [
  'opt1Enabled', 'opt2Enabled', 'opt3Enabled', 'opt4Enabled',
  'opt5Enabled', 'opt6Enabled', 'opt8Enabled',
]

function pickInput(cfg) {
  const out = {}
  BOOL_FIELDS.forEach(k => { if (cfg?.[k] != null) out[k] = !!cfg[k] })
  NUM_FIELDS.forEach(k => {
    if (cfg?.[k] != null && cfg[k] !== '') {
      const n = parseFloat(cfg[k])
      if (Number.isFinite(n)) out[k] = n
    }
  })
  return out
}

export default function PayoutSettings() {
  const { data, loading, error, refetch } = useQuery(GET, { fetchPolicy: 'cache-and-network' })
  const [cfg, setCfg] = useState(null)
  const [saved, setSaved] = useState(false)
  const [save, { loading: saving, error: saveError }] = useMutation(SAVE, {
    onCompleted: () => { setSaved(true); refetch() },
  })

  useEffect(() => {
    if (data?.platformPayoutConfig) setCfg(data.platformPayoutConfig)
  }, [data])

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 6 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          Platform Driver Payout Settings
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Controls how RushMyFood platform drivers (driverType: RUSHMYFOOD) are paid for each
          delivery and per-shift. Options can be combined — every enabled option is added on top.
        </Typography>

        {loading && !data && <CircularProgress />}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error.message}</Alert>}
        {saveError && <Alert severity="error" sx={{ mb: 2 }}>{saveError.message}</Alert>}
        {saved && <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSaved(false)}>Saved.</Alert>}

        {cfg && (
          <>
            <PayoutConfigForm value={cfg} onChange={setCfg} disabled={saving} />
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                disabled={saving}
                onClick={() => { setSaved(false); save({ variables: { input: pickInput(cfg) } }) }}
              >
                {saving ? 'Saving…' : 'Save settings'}
              </Button>
            </Box>
          </>
        )}
      </Paper>
    </Container>
  )
}
